<template>
  <div id="kurz-kresby">
    <div class="content">
      <div class="header-button-wrapper">
        <div class="header-text">
          <h1>kurz kresby 2026</h1>
          <h2 class="subtitle">možnosti kresby — inšpirácie prírodou II.</h2>
          <p class="date">24. 10. – 25. 10. 2026 · Liptovský Michal</p>
        </div>
      </div>

      <div class="hero-intro">
        <div class="hero-gallery">
          <ImageViewport :sources="courseImages" folder="drawing-course-photos" blurred-background/>
        </div>

        <p class="intro">
          Kurz približujúci kresbu ako základ a východisko do iných výtvarných disciplín.
          Pracovné stretnutia sa uskutočnia v starej záhrade a krajine v Liptovskom Michale
          (Dvor u Maliara). Prebiehať budú v dvoch dňoch.
        </p>
      </div>

      <section class="program">
        <h2>program</h2>

        <div class="day-block">
          <h3>sobota</h3>
          <ul>
            <li>stretnutie účastníkov kurzu, informácie o programe, teoretická časť, špecifiká kresby</li>
            <li>bod, línia, tvar, rytmus, proporčnosť, svetlo, kontrast</li>
            <li>kompozícia</li>
            <li>kresliace materiály a techniky — ceruza, rudka, uhoľ, tuš, pastel, alternatívne médiá</li>
            <li>ukážky a analýzy diel významných domácich a zahraničných autorov</li>
            <li>popoludní výber motívov na základe inšpirácií, práca v teréne</li>
            <li>večer korekcie prác</li>
          </ul>
        </div>

        <div class="day-block">
          <h3>nedeľa</h3>
          <ul>
            <li>dopoludnia práca v teréne, čiastočné korekcie diel</li>
            <li>popoludní zhodnotenie kurzu, naznačenie ďalších východísk a smerovaní, záver</li>
          </ul>
        </div>
      </section>

      <section class="notes">
        <h2>poznámky</h2>
        <p>Kresliaci materiál (ceruzy, uhoľ, rudka, pastel, podložky na prácu) dostanú účastníci zdarma</p>
        <p>So sebou si prineste:</p>
        <ul>
          <li>skicár formátu A4, A3 (menšia alebo väčšia gramáž papiera)</li>
          <li>lepiacu pásku, pripínačky, plastickú gumu, fixatív</li>
        </ul>
        <p>Počas kurzu možnosť nazrieť do monografií, katalógov a časopisov domácich i zahraničných autorov</p>
        <p>Debaty o tendenciách súčasného výtvarného umenia</p>
      </section>

      <div class="details-card">
        <p><strong>Kurz vedie:</strong> prof. akad. mal. Ján Kudlička</p>
        <p><strong>Poplatok za 2-dňový kurz:</strong> 60&nbsp;€ na osobu</p>
      </div>

      <div v-if="this.$store.getters.isMobile" class="buttons">
        <button class="cfa-button" @click="contactFormOpen = !contactFormOpen">PRIHLÁSIŤ&nbsp;SA</button>
      </div>

      <section v-if="this.$store.getters.isPc" class="signup">
        <h2>prihlásiť sa</h2>
        <p class="signup-intro">Vyplňte formulár a my sa vám čo najskôr ozveme s ďalšími informáciami o kurze</p>
        <ContactForm @sending="this.sending = true" @emailSent="this.sending = false" :templateParams="this.tp">
          <input v-model="this.tp.from_name" class="name" name="name" placeholder="Meno" required type="text"/>
          <input v-model="this.tp.from_email" class="address" name="email" placeholder="E-mail" required type="email"/>
          <textarea v-model="this.userMessage" class="message" required rows="6"/>
          <button class="cfa-button" v-if="!sending" type="submit">ODOSLAŤ</button>
          <div class="lds-dual-ring" v-if="sending"></div>
        </ContactForm>
      </section>
    </div>
  </div>

  <div v-if="this.$store.getters.isMobile && this.contactFormOpen" id="fixed-contact-form">
    <button class="cancel-button cfa-button" @click="contactFormOpen = !contactFormOpen">ZRUŠIŤ</button>
    <ContactForm @sending="this.sending = true" @emailSent="() => {
        contactFormOpen = false
        sending = false
      }" :templateParams="this.tp">
      <input v-model="this.tp.from_name" class="name" name="name" placeholder="Meno" required type="text"/>
      <input v-model="this.tp.from_email" class="address" name="email" placeholder="E-mail" required type="email"/>
      <textarea v-model="this.userMessage" class="message" required rows="6"/>
      <button class="cfa-button" v-if="!sending" type="submit">ODOSLAŤ</button>
      <div class="lds-dual-ring" v-if="sending"></div>
    </ContactForm>
  </div>

  <Footer/>
</template>

<script>
import Footer from "@/components/Footer"
import ContactForm from "@/components/ContactForm"
import ImageViewport from "@/components/ImageViewport"

export default {
  name: "KurzKresby2026",
  components: {
    Footer,
    ContactForm,
    ImageViewport
  },
  data: () => {
    return {
      contactFormOpen: false,
      sending: false,
      courseImages: ["poster.webp", "course1.jpeg", "course2.jpeg", "course3.jpeg"],
      userMessage: "Mám záujem o kurz kresby 2026 (24.–25. 10. 2026).",
      tp: {
        message: "— Prihláška z formulára kurzu kresby 2026 (24.–25. 10. 2026) —\n\nMám záujem o kurz kresby 2026 (24.–25. 10. 2026)."
      }
    }
  },
  watch: {
    userMessage (val) {
      this.tp.message = "— Prihláška z formulára kurzu kresby 2026 (24.–25. 10. 2026) —\n\n" + val
    }
  }
}
</script>

<style>

#kurz-kresby {
  width: 100%;
  padding: calc(var(--nav-height) + 30px) var(--side-margin) var(--side-margin) var(--side-margin);

  display: flex;
  justify-content: center;
}

#kurz-kresby .content {
  width: 100%;
  max-width: var(--m-stretch-limit-large);
}

#kurz-kresby .header-button-wrapper {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 2px solid black;
  padding-bottom: 20px;
  margin-bottom: 30px;
}

#kurz-kresby .header-text {
  flex: 1 1 auto;
  min-width: 0;
}

#kurz-kresby .header-text h1 {
  word-wrap: break-word;
}

#kurz-kresby .header-text .subtitle {
  margin-top: 12px;
  font-size: 1.6em;
  color: var(--text-secondary);
  font-weight: 300;
}

#kurz-kresby .header-text .date {
  margin-top: 10px;
  color: var(--text-secondary);
  font-style: italic;
}

#kurz-kresby .hero-intro {
  display: flex;
  flex-flow: column nowrap;
  gap: 35px;
  margin-bottom: 35px;
}

#kurz-kresby .hero-gallery {
  width: 100%;
  height: 40vh;
  min-height: 220px;
  max-height: 380px;
}

#kurz-kresby .hero-gallery .image-viewport-container {
  height: 100%;
}

#kurz-kresby .intro {
  font-size: 1.5em;
  line-height: 1.6;
  padding: 0 5px;
}

#kurz-kresby section {
  margin-bottom: 40px;
}

#kurz-kresby section > h2 {
  position: relative;
  padding: 20px 0 8px 0;
  margin-bottom: 25px;
}

#kurz-kresby section > h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 80%;
  border-bottom: 2px solid black;
}

#kurz-kresby .program .day-block {
  margin-bottom: 28px;
  padding-left: 5px;
}

#kurz-kresby .program .day-block h3 {
  font-size: 1.8em;
  font-weight: 500;
  color: var(--highlight);
  margin-bottom: 14px;
}

#kurz-kresby .program ul,
#kurz-kresby .notes ul {
  padding-left: 25px;
  margin: 10px 0;
}

#kurz-kresby .program li,
#kurz-kresby .notes li {
  padding: 5px 0;
  line-height: 1.5;
  color: var(--text-secondary);
}

#kurz-kresby .notes p {
  margin: 12px 0;
  line-height: 1.6;
  padding: 0 5px;
}

#kurz-kresby .details-card {
  background-color: var(--highlight-transparent);
  border-radius: 5px;
  padding: 25px 30px;
  margin-bottom: 35px;
}

#kurz-kresby .details-card p {
  padding: 8px 0;
  font-size: 1.3em;
  color: var(--text-primary);
}

#kurz-kresby .details-card strong {
  font-weight: 500;
}

#kurz-kresby > .content > .buttons {
  display: flex;
  flex-flow: row wrap;
  margin-top: 25px;
  margin-bottom: 25px;
}

#kurz-kresby > .content > .buttons .cfa-button {
  height: 45px;
  padding: 0 50px;
  margin-right: 15px;
}

#kurz-kresby .signup .signup-intro {
  margin-bottom: 25px;
  line-height: 1.6;
}

@media only screen and (min-width: 1200px) {
  #kurz-kresby {
    padding: calc(var(--nav-height) + 60px) var(--side-margin) var(--side-margin) var(--side-margin);
  }

  #kurz-kresby .content {
    max-width: 1100px;
  }

  #kurz-kresby .header-text .subtitle {
    font-size: 2.2em;
  }

  #kurz-kresby .header-text .date {
    font-size: 1.5em;
  }

  #kurz-kresby .intro {
    font-size: 1.7em;
  }

  #kurz-kresby .hero-intro {
    flex-flow: row nowrap;
    align-items: flex-start;
    gap: 40px;
  }

  #kurz-kresby .hero-intro > * {
    flex: 1 1 0;
    min-width: 0;
  }

  #kurz-kresby .program .day-block h3 {
    font-size: 2.2em;
  }

  #kurz-kresby .details-card p {
    font-size: 1.5em;
  }
}

</style>
